import { profile, links } from '../content/site.js';

export const yearsCoding = 10;
export const projectCount = 12;
export const languagesSpoken = 5;

const profileData = { ...profile, ...links, yearsCoding, projectCount, languagesSpoken };
export default profileData;
